<template>
  <div class="wrapper">
    <Header :name="$t('app.company.settingsTitle')" />
    <TabsNavigation :tabs="tabsTitle" @changeTab="(value) => (state.currentTab = value)" />
    <transition mode="out-in" name="fade">
      <component :is="tabsContent[state.currentTab]" />
    </transition>
  </div>
</template>

<script setup lang="ts">
import { reactive, computed } from "vue";
import Header from "@/components/Header.vue";
import History from "./partials/History.vue";
import Members from "./partials/Members.vue";
import Informations from "./partials/Informations.vue";
import Archives from "./partials/Archives.vue";

import { canWriteBillings, canWriteMembers } from "@/composables/permissions";
import { useRoles } from "@/queries/user.query.js";

const { t } = useI18n();

const { data: roles, isPending: isRolesPending } = useRoles();

const tabsTitle = computed(() => {
  const array = [];

  if (isRolesPending.value) return array;

  if (canWriteMembers.value(roles.value)) {
    array.push(t("app.company.usersTab"));
    array.push(t("app.company.archivedTab"));
  }

  if (canWriteBillings.value(roles.value)) {
    array.push(t("app.company.transactionsTab"));
    array.unshift(t("app.company.infoTab"));
  }

  return array;
});

const tabsContent = [Informations, Members, History, Archives];

const state = reactive({
  currentTab: 0,
});
</script>
